import { fetchFactory } from 'isotope-client'

export const reCalculateQuery = (idCampagne) => fetchFactory(`/calcul/${idCampagne}`)

export const reCalculateFerme = () => fetchFactory(`/calcul`)

export const reCalculateTachesFerme = (idFerme) => fetchFactory(`/calcul/${idFerme}/taches`)